<div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 dialogHeader">
	<h2 mat-dialog-title >{{ data.title }}</h2>
</div>
<div mat-dialog-content>
	<p class="notice-text pl-6">{{ data.message }}</p>
</div>
<div class="dialogContentContainer">
	<div mat-dialog-actions align="end">
		<button
			mat-button
			mat-raised-button
			color="green"
			cdkFocusInitial
			(click)="confirm()"
			class="dialog-confirm-button"
		>
			{{ data.buttonText }}
		</button>
	</div>
</div>
